<template>
	<div>
		<div class="news">
			<!-- onclick="window.open('http://yigee.cn:81/view/CompanyIntroduction.aspx')" -->
			<!-- <ul class="dian" v-html="context">
			</ul> -->
			<el-row class="new">
				<el-col v-for="(item,index) in news" :key="item.id" class="news-item">
					<router-link :to="'/home/news/'+item.id">
						<el-row>
							<el-col :span="6">
								<img :src="item.thumb" />
							</el-col>
							<el-col :span="18">
								<div class="item-text-title">{{item.title}}</div>
								<div class="item-text-content">
									<p> {{item.content.substring(0,110)}}{{item.content.length>110?'...':''}} </p>
								</div>
								<div class="item-text-date">{{ (item.createTime+'').substring(0,(item.createTime+'').indexOf(' ')) }}</div>
							</el-col>
						</el-row>
					</router-link>
				</el-col>
			</el-row>
		</div>
		<el-pagination background layout="prev, pager, next" :total="count" :page-size="4" @current-change="sizeChang" style="text-align: center;margin-top: 20px;"></el-pagination>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations
	} from 'vuex'
	export default {
		data() {
			return {
				context: '',
				count: 2,
				page_index: 1,
				news: []
			}
		},
		methods: {
			...mapMutations(['setNews']),
			News() {
				this.$http.get('news/GetNews.do').then(res => {
					this.news = res.data
					this.setNews(res.data)
				})
			},
			sizeChang(e) {
				this.page_index = e
				this.News()
			}
		},
		created() {
			this.News()
		}
	}
</script>

<style >
	.news {
		background: #fff;
		padding: 40px;
		min-height: 400px;
		cursor: pointer;
	}
	
	.news ul {
		margin: 0;
		padding: 0;
	}
	
	.news ul li {
		list-style: none;
		width: 700px;
		height: 150px;
		margin: 0;
		padding: 0;
	}
	
	.news ul li p {
		font-size: 58px;
		color: #ccc;
		width: 67px;
		float: left;
		margin: 0;
	}
	
	.news ul li .news_you_tu {
		margin-left: 120px;
		height: 120px;
		overflow: hidden;
	}
	
	.news ul li .news_you_tu h4 {
		font-size: 22px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		margin: 0;
		color: #222;
	}
		
	.news ul li .news_you_tu span {
		height: 45px;
		overflow: hidden;
		text-overflow: ellipsis;
		/* white-space: nowrap; */
		display: block;
		line-height: 1.5;
		font-size: 16px;
		color: #666;
	}
		
	.news ul li .news_you_tu .clickNews {
		padding-top: 10px;
		text-align: right;
		font-size: 12px;
	}
	
	.news ul li img {
		border: 0px;
		display: block;
		clear: both;
	}

	.new {
		margin: auto;
	}
	
	.news-item:hover {
		box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
		margin-left: 20px;
	}
	
	.news-item {
		margin-top: 10px;
		padding: 30px;
		position: relative;
		width: 100%;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 0px 10px 0px transparent;
		transition: .3s;
	}
	
	.news-item a {
		text-decoration: none;
		color: #000;
	}
	
	.news-item a img {
		width: 200px;
		height: 120px;
	}
	
	.news-item a .item-text-title {
		padding-left: 20px;
		font-size: 18px;
		font-weight: 700;
	}
	
	.news-item a .item-text-content {
		padding-left: 20px;
		color: #192944;
		font-size: 14px;
		text-indent: 1rem;
	}
	
	.news-item a .item-text-date {
		padding-left: 20px;
		color: #9BA5B7;
		bottom: 0;
		right: 30px;
		width: 100%;
		position: relative;
		text-align: right;
	}
</style>
